export default "__VITE_ASSET__33L1wVR9__"